import React from "react";

import { Box } from "@mui/material";

import { ShortTextBlock, ShortTextResponse } from "../types";

interface Props {
  question: ShortTextBlock;
  response: ShortTextResponse;
}

const ShortText: React.FC<Props> = ({ question, response }) => {
  return (
    <Box>
      <Box fontSize={14} fontWeight="600" color="#7D8797">
        {question.data.title}
      </Box>
      <Box
        display="inline-block"
        p="16px"
        border="1px solid #DEE6F0"
        mt="12px"
        minWidth="50%"
      >
        {response.data}
      </Box>
    </Box>
  );
};

export default ShortText;
